import { EcpBankAccountType } from "frontend-client";

export const getAccountType = (type: EcpBankAccountType | undefined) => {
  if (!Number.isNaN(type)) {
    switch (type) {
      case EcpBankAccountType.CUSTOMER_CHECKING:
        return "checking";
      case EcpBankAccountType.CUSTOMER_SAVINGS:
        return "savings";
      case EcpBankAccountType.COMMERCIAL_CHECKING:
        return "commercialChecking";
    }
  }
  return type;
};
